import React, { useState, useEffect, useReducer } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  Upload,
} from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined, TeamOutlined, PictureOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";
import { reducerRegister } from "../../../helpers/reducers";
const { Text, Link } = Typography;

export const EleicoesCipaCandidatos = ({ to }) => {
  const navigate = useNavigate();
  const { id_eleicoes, id_eleicoes_localidades } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [eleicao, setEleicao] = useState({});
  const [colaboradores, setColaboradores] = useState([]);
  const [eleicaoLocalidade, setEleicaoLocalidade] = useState({});

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);

  useEffect(() => {
    listarColaboradores();
  }, []);

  useEffect(() => {
    if (id_eleicoes) carregarEleicao(id_eleicoes);
  }, [id_eleicoes]);

  useEffect(() => {
    if (id_eleicoes_localidades) {
      carregarEleicaoLocalidade(id_eleicoes_localidades);
      listarCandidatos(id_eleicoes_localidades);
    }
  }, [id_eleicoes_localidades]);

  // CARREGAR ELEIÇÃO
  const carregarEleicao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_eleicoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) setEleicao(api.response.data);
    } else {
      message.error(api.response.message);
      navigate(`${to}/${id_eleicoes}`);
    }
    setLoading(false);
  };

  // CARREGAR ELEIÇÃO LOCALIDADE
  const carregarEleicaoLocalidade = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_eleicoes_localidades/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) setEleicaoLocalidade(api.response.data);
    } else {
      message.error(api.response.message);
      navigate(`${to}/${id_eleicoes}`);
    }
    setLoading(false);
  };

  // LISTAR COLABORADORES
  const listarColaboradores = async (pesquisa_colaboradores = "") => {
    const api = await http("get", `v1/usuario/pesquisar_colaboradores?pesquisa=${pesquisa_colaboradores}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      let array_colaboradores = [];
      if (!!response) {
        for (let col of response) {
          array_colaboradores.push({
            value: col.id,
            label: `${col.matricula} - ${col.nome}`,
          });
        }
      }
      setColaboradores(array_colaboradores);
    } else {
      message.error(api.response.message);
    }
  };

  // LISTAR
  const listarCandidatos = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_candidatos/listar/${id}`, []);
    if (api.statusCode === 200) {
      dispatch({ type: "LOAD", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarCandidato = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_candidatos/adicionar`, formulario, "multipart/form-data");
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      if (api?.response?.data) dispatch({ type: "ADD", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarCandidato = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_candidatos/alterar`, formulario, "multipart/form-data");
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      if (api?.response?.data) dispatch({ type: "UPDATE", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarCandidato = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_candidatos/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      const response = api?.response?.data;
      if (response?.id_colaborador > 0) {
        setColaboradores([
          { value: response?.id_colaborador, label: `${response?.matricula} - ${response?.colaborador}` },
        ]);
      }
      form.setFieldsValue({
        id_colaborador: api.response.data.id_colaborador,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarCandidato = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_candidatos/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      dispatch({ type: "DELETE", payload: { id: id } });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR IMAGEM
  const deletarCandidatoImagem = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_candidatos_imagens/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      const index = dados?.findIndex((obj) => obj?.id === id);
      dispatch({ type: "UPDATE", payload: { ...dados[index], arquivo: "" } });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR IMAGEM
  const carregarCandidatoImagem = async (id, nome) => {
    if (!id) return;
    setLoading(true);
    const api = await http("file", `v1/eleicoes_cipa_candidatos_imagens/carregar/${id}`, []);
    if (api.statusCode === 200) {
      // DOWNLOAD FILE
      let a = document.createElement("a");
      const url = window.URL.createObjectURL(api?.response?.data);
      a.href = url;
      a.download = nome;
      a.click();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Candidato",
      dataIndex: "colaborador",
    },
    {
      title: "Filial",
      dataIndex: "filial",
    },
    {
      title: "Imagem",
      dataIndex: "arquivo",
      render: (_, e) =>
        e?.arquivo ? (
          <Space wrap>
            <Link onClick={() => carregarCandidatoImagem(e?.id, e?.arquivo)}>{e?.arquivo}</Link>
            {eleicao?.status_gerado === 0 && eleicao?.status === -1 && (
              <Button
                type="link"
                danger
                icon={<DeleteOutlined />}
                onClick={() => {
                  modal.confirm({
                    title: "Deseja deletar este registro?",
                    okText: "Sim",
                    cancelText: "Cancelar",
                    onOk() {
                      deletarCandidatoImagem(e.id);
                    },
                  });
                }}
              />
            )}
          </Space>
        ) : (
          <Text disabled>Sem imagem</Text>
        ),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 50,
      sorter: false,
      render: (_, e) =>
        eleicao?.status_gerado === 0 &&
        eleicao?.status === -1 && (
          <Space.Compact>
            <Tooltip title="Editar">
              <Button loading={loading} onClick={() => carregarCandidato(e.id)} icon={<EditOutlined />} />
            </Tooltip>
            <Tooltip title="Excluir">
              <Button
                danger
                loading={loading}
                icon={<DeleteOutlined />}
                onClick={() => {
                  modal.confirm({
                    title: "Deseja deletar este registro?",
                    okText: "Sim",
                    cancelText: "Cancelar",
                    onOk() {
                      deletarCandidato(e.id);
                    },
                  });
                }}
              />
            </Tooltip>
          </Space.Compact>
        ),
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    const form = new FormData();
    form.append("id_colaborador", formulario?.id_colaborador);
    form.append("id_eleicoes_localidades", id_eleicoes_localidades);
    form.append("arquivo", formulario?.arquivo?.[0]?.originFileObj ?? "");

    if (idAlt > 0) {
      form.append("id", idAlt ?? 0);
      alterarCandidato(form);
    } else {
      cadastrarCandidato(form);
    }
  };

  const formFile = (e) => {
    const formato = e?.file?.type === "image/jpeg" || e?.file?.type === "image/png";
    if (!formato) {
      message.error("Selecione uma imagem PNG/JPG!");
      return null;
    }
    const size = e?.file?.size / 1024 / 1024 > 10;
    if (size) {
      message.error("Tamanho não suportado, máximo 10MB!");
      return null;
    }

    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  // FORMULÁRIO
  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Candidato
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1000}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              name="id_colaborador"
              label="Colaborador"
              rules={[{ required: true, message: "Selecione o colaborador!" }]}>
              <Select
                showSearch
                size="large"
                placeholder="Selecione o colaborador"
                disabled={loading || idAlt > 0}
                style={{ width: "100%" }}
                options={colaboradores}
                onSearch={(e) => listarColaboradores(e)}
                filterOption={false}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={24}>
            <Form.Item
              getValueFromEvent={formFile}
              name="arquivo"
              label="Imagem"
              valuePropName="fileList"
              multiple={false}>
              <Upload.Dragger
                disabled={loading}
                beforeUpload={() => false}
                accept=".jpeg, .jpg, .png"
                listType="picture"
                maxCount={1}
                multiple={false}>
                <p className="ant-upload-drag-icon">
                  <PictureOutlined />
                </p>
                <p className="ant-upload-text">Adicione aqui a foto (PNG, JPG, JPEG)</p>
                <p className="ant-upload-hint">Clique ou arraste para enviar o arquivo</p>
              </Upload.Dragger>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Eleições CIPA" onClickBack={() => navigate(`${to}/${id_eleicoes}`)} />
            <HeaderTitle
              title={["Eleições", "Localidades", "Candidatos"]}
              subtitle={eleicaoLocalidade?.localidade ?? ""}
              icon={<TeamOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  eleicao?.status_gerado === 0 &&
                  eleicao?.status === -1 && (
                    <Tooltip title="Adicionar Registro">
                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => {
                          setShowModal(true);
                          resetForm();
                        }}
                        loading={loading}>
                        Novo
                      </Button>
                    </Tooltip>
                  )
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
